"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getDecoratedComponent(instanceRef) {
    var currentRef = instanceRef.current;
    if (currentRef == null) {
        return null;
    }
    else if (typeof currentRef.getDecoratedComponentInstance === 'function') {
        return currentRef.getDecoratedComponentInstance();
    }
    else {
        return currentRef;
    }
}
exports.getDecoratedComponent = getDecoratedComponent;
